const getLogoURL = () => {
  var logoUrl = 'https://appapi.webcolms.com/public/logos'
  var adminDomainURL = document.location.origin
  if (adminDomainURL == 'https://passinstitute.webcolms.com') {
    logoUrl = logoUrl + "/pass"
  } else if (adminDomainURL == 'https://nanaska.webcolms.com') {
    logoUrl = logoUrl + "/nanaska"
  }else if (adminDomainURL == 'https://students.goldmarchcoaching.com') {
    logoUrl = logoUrl + "/goldmarchcoaching"
  } else if (adminDomainURL == 'https://students.moosdigitalschool.com'){
    logoUrl = logoUrl + "/moosdigitalschool"
  }
  return logoUrl
}

const getLoginBackground = () => {
  var loginBackground = 'https://appapi.webcolms.com/public/logos/new-2.jpg'
  var adminDomainURL = document.location.origin
  if (adminDomainURL == 'https://passinstitute.webcolms.com') {
    loginBackground = 'https://appapi.webcolms.com/public/logos/new-2.jpg'
  } else if (adminDomainURL == 'https://nanaska.webcolms.com') {
    loginBackground = 'https://appapi.webcolms.com/public/logos/nanaska/nanaska.jpg'
  }
  return loginBackground
}

const getClientName = () => {
  var clientName = 'LMS'
  var adminDomainURL = document.location.origin
  if (adminDomainURL == 'https://passinstitute.webcolms.com') {
    clientName = 'PASS'
  } else if (adminDomainURL == 'https://nanaska.webcolms.com') {
    clientName = 'NANASKA-LMS'
  } else if (adminDomainURL == 'https://students.moosdigitalschool.com'){
    clientName = 'MOOS Digital School'  
  }
  return clientName
}

const getSubtitle = () => {
  var subtitle = 'Online Education'
  var adminDomainURL = document.location.origin
  if (adminDomainURL == 'https://nanaska.webcolms.com') {
    subtitle = ''
  }
  return subtitle
}

module.exports = {
  API_URL: 'https://appapi.webcolms.com/public',
  EXAM_DOCUMENTS: 'https://appapi.webcolms.com/public/question-bank-uploads/',
  Documents_URL: 'https://appapi.webcolms.com/public/storage/documents',
  Assignment_URL: 'https://appapi.webcolms.com/public/storage/assignments',
  LOGO_URL: getLogoURL,
  LOGIN_BACKGROUND: getLoginBackground,
  Client_name: getClientName,
  loginSubtitle: getSubtitle,
  Merchant_id: '1215116',
  zoomAPIKey: 'tgb0EtBbRR6kI0YOR6Y-Sw',
  zoomAPISecret: 'I3g9XiN8Jvzk5Zgi0Cbv1PcOOVuTjNcsjz6P',
  clientFeature: {
    showQuiz: true,
    vimeoControls: true,
    payOnline: false,
    topicVideoFaceCapture: false
  }
}
